import './styles/delivery-config-details.scss'

import React      from 'react'
import PropTypes  from 'prop-types'

import DetailsSection from '../components/DetailsSection'
import DetailsHeader  from '../components/DetailsHeader'
import Loading        from '../components/Loading'

import GenericConfigDetails from '../components/GenericConfigDetails'

import api from '../redux/api'

export default class DeliveryConfigDetails extends React.Component {
  static propTypes = {
    match:   PropTypes.object.isRequired,
  }

  state = {
    data:    null,
    loading: true,
  }

  componentDidMount() {
    const { id } = this.props.match.params

    api.loadDeliveryConfig(id).then((result) => {
      this.setState({ loading: false, data: result })
    })
  }

  render() {
    const { loading, data } = this.state

    if (loading) return <Loading />

    return (
      <div className="delivery-config-details">
        <DetailsHeader title={data.name} type={'DeliveryConfig'} />

        <div className="config-details">
          <DetailsSection
            title="Receiver"
            name={data.receiver.name}
            description={data.receiver.description}
            url={`/data-systems/item/${data.receiver.id}`}
          />

          {data.sender && (
            <DetailsSection
              title="Sender"
              name={data.sender.name}
              description={data.sender.description}
              url={`/data-systems/item/${data.sender.id}`}
            />
          )}

          {data.dataType && (
            <DetailsSection
              title="Data Type"
              name={data.dataType.name}
              description={data.dataType.description}
              url={`/data-types/item/${data.dataType.id}`}
            />
          )}

          <DetailsSection title="Service" description={data.deliveryService} />

          {data.config && (
            <GenericConfigDetails title={`${data.deliveryService} Delivery Config`} config={data.config} />
          )}
        </div>
      </div>
    )
  }
}